import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/app.hooks';
import { ITelemetryProps } from './telemetry.model';
import React from 'react';
//import AddTelemetryModal from './AddTelemetryModal';
import { useHistory, useParams } from 'react-router-dom';
import MainTable from './MainTable';
import { clearTelemetry, telemetrySelector } from '../../../store/master/telemetry/telemetry.reducer';
import { Button } from 'antd';
import { Can } from '../../../common/ability';
import { Action, Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import GlobalSearch from '../../../common/components/globalSearch/GlobalSearch';

const Telemetry: React.FC<ITelemetryProps> = () => {
  const telemetry = useAppSelector(telemetrySelector);
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();

  //const [addModalVisible, setAddModalVisible] = React.useState(false);
  //const [id, setId] = React.useState(0);
  const [showSelectedListModal, setShowSelectedListModal] = React.useState(false);
  //const [valuesForSelection, setValuesForSelection] = React.useState(null);
  const { id: bg_process_id } = useParams<{ id?: string }>();

  useEffect(() => {
    setShowSelectedListModal(false);
    return () => {
      dispatch(clearTelemetry());
    };
  }, []);

  useEffect(() => {
    dataTableRef?.current.refreshData();
  }, [bg_process_id]);

  const tableButtons = () => (
    <>
      <Can I={Action.UpdateFromExcel} a={Page.Telemetry}>
        <Button
          className="btn-icon"
          onClick={() =>
            history.push(`/data-input/bulk-update-from-excel/${encodeURIComponent(telemetry.search.tableName)}`)
          }
          icon={
            <em className="anticon">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                alt=""
              />
            </em>
          }
        >
          Update from Excel
        </Button>
      </Can>
      <Can I={Action.ImportToExcel} a={Page.Telemetry}>
        <Button
          className="btn-icon"
          onClick={() =>
            history.push(`/data-input/bulk-import/${encodeURIComponent(telemetry.search.tableName)}`)
          }
          icon={
            <em className="anticon">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                alt=""
              />
            </em>
          }
        >
          Import
        </Button>
      </Can>
    </>
  );

  return (
    <div className="telemetry">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.Telemetry} />
        </h4>
        <div className="right-title">
          <GlobalSearch />
        </div>
        <div className="btns-block">
          <Button
            className="btn-icon"
            type="primary"
            onClick={() => history.goBack()}
            icon={
              <em className="anticon">
                <img src={`${process.env.PUBLIC_URL}/assets/images/ic-left-arrow.svg`} alt="" />
              </em>
            }
          >
            Back
          </Button>
        </div>
      </div>
      <div className="main-card">
        {/* <div className="input-btns-title">
          <Row gutter={[10, 4]}>
            <Can I={Action.ImportToExcel} a={Page.Telemetry}>
              <Col>
                <Button
                  className="btn-icon"
                  onClick={() =>
                    history.push(
                      `/data-input/bulk-import/${encodeURIComponent(telemetry.search.tableName)}`
                    )
                  }
                  icon={
                    <em className="anticon">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                        alt=""
                      />
                    </em>
                  }
                >
                  Import
                </Button>
              </Col>
            </Can>
          </Row>
        </div> */}
        <MainTable
          ref={dataTableRef}
          isMultiple={showSelectedListModal}
          //setValuesForSelection={setValuesForSelection}
          setShowSelectedListModal={(state) => {
            //setId(0);
            setShowSelectedListModal(state);
          }}
          tableButtons={tableButtons}
          anyId={+bg_process_id > 0 ? +bg_process_id : undefined}
        />
      </div>
      {/*{addModalVisible && (
        <AddTelemetryModal
          showModal={addModalVisible}
          isMultiple={false}
          handleModalClose={() => {
            setAddModalVisible(false);
            history.push('/administration/telemetry');
          }}
          id={id}
          refreshDataTable={() => refreshDataTable()}
        />
      )}
      {showSelectedListModal && (
        <AddTelemetryModal
          showModal={showSelectedListModal}
          valuesForSelection={valuesForSelection}
          isMultiple={true}
          handleModalClose={() => {
            setShowSelectedListModal(false);
            history.push('/administration/telemetry');
          }}
          id={id}
          refreshDataTable={() => refreshDataTable()}
        />
      )} */}
    </div>
  );
};

export default Telemetry;
